import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SCORE_COPY } from '../components/creditscore/scoreCopy';
import { ScoreHero, ScoreImpact, ScoreFactors, ScoreRebuild, ScoreCta } from '../components/creditscore/ScoreSections';
import { CalcFaq } from '../components/calculator/CalcSections';

export default function CreditScore() {
  const { language } = useLanguage();
  const c = SCORE_COPY[language === 'en' ? 'en' : 'fr'];

  useEffect(() => {
    document.title = c.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', c.meta);
    const ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.text = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: c.faq.map(([q, a]) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })) });
    document.head.appendChild(ld);
    return () => ld.remove();
  }, [c]);

  return (
    <div className="min-h-screen pt-24 md:pt-[120px] bg-white" data-testid="credit-score-page">
      <ScoreHero c={c} />
      <ScoreImpact c={c} />
      <ScoreFactors c={c} />
      <ScoreRebuild c={c} />
      <CalcFaq c={c} />
      <ScoreCta c={c} />
    </div>
  );
}
